import { useState, useEffect } from "react";
import { Card, Button, Table, Spinner, Alert, Row, Col } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { decryptData, formataDataHoraExibicao } from "../../common/utils";
import StatusBadge from "./StatusBadge";
import Paginacao from "../../common/pagination";

const PrestadorPage = () => {
  const [meusReportes, setMeusReportes] = useState({
    results: [],
    count: 0,
    next: null,
    previous: null,
  });
  const [page_numb, setPageNumb] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fetchMeusReportes = async (page = page_numb) => {
    try {
      const dados_outros = decryptData("o");
      const prestadorId = dados_outros?.prestador_id;

      if (!prestadorId) {
        setError(
          "ID do prestador não encontrado. Não foi possível carregar seus reportes."
        );
        setLoading(false);
        return;
      }

      const response = await api.get(
        `/formularios/respostas/?prestador_id=${prestadorId}&page=${page}`
      );
      setMeusReportes(response.data);
    } catch (error) {
      console.error("Erro ao buscar reportes:", error);
      setError(
        "Ocorreu um erro ao buscar seus reportes. Tente novamente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  };

  const onClickPagina = (num_page) => {
    setPageNumb(num_page);
    fetchMeusReportes(num_page);
  };

  useEffect(() => {
    fetchMeusReportes();
  }, [page_numb]);

  return (
    <div>
      <Row className="align-items-center">
        <Col sm={6} lg={6}>
          <h4 className="page-title">Reportes de Farmacovigilância</h4>
        </Col>
        <Col sm={6} lg={6} className="text-end">
          <Button
            variant="secondary"
            onClick={() => navigate("/reportes-farmaco/novo")}
            className="mb-3"
            size="sm"
          >
            <FaPlus /> Criar Novo Reporte
          </Button>
        </Col>
      </Row>

      <Card className="cardDestaque">
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}

          <Table responsive className="custom-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Data de Envio</th>
                <th>Paciente</th>
                <th>Atendimento ID</th>
                <th>Medicamento</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    <Spinner animation="border" />
                  </td>
                </tr>
              ) : meusReportes.results && meusReportes.results.length > 0 ? (
                meusReportes.results.map((reporte) => {
                  const nomePaciente =
                    reporte.dados_beneficiario?.nome?.trim() ||
                    reporte.dados_beneficiario?.nome_completo?.trim() ||
                    null;

                  const iniciaisPaciente =
                    reporte.respostas?.paciente_nome_iniciais?.trim() || null;

                  return (
                    <tr
                      key={reporte.id}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/reportes-farmaco/detalhe/${reporte.id}`)
                      }
                    >
                      <td>{reporte.id}</td>
                      <td>{formataDataHoraExibicao(reporte.data_cadastro)}</td>
                      <td>
                        {nomePaciente ? (
                          nomePaciente
                        ) : iniciaisPaciente ? (
                          <span className="text-muted">{iniciaisPaciente}</span>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{reporte.dados_atendimento?.id || "-"}</td>
                      <td>{reporte.respostas?.medicamento_nome || "-"}</td>
                      <td>
                        <StatusBadge status={reporte.status} />
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    Nenhum reporte enviado.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {meusReportes.results && meusReportes.results.length > 0 && (
            <Paginacao
              dados={meusReportes}
              loading={loading}
              page_numb={page_numb}
              _onClickPagina={onClickPagina}
            />
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PrestadorPage;
